import { awsPartitionFromUse } from "@p0security/integrations-aws-shared/gov-cloud";
import { existingIamWriteAndAssessmentItems } from "@p0security/integrations-aws-shared/install-options";
import {
  accessLogsInstallCommands,
  accessLogsTerraform,
} from "@p0security/integrations-aws-shared/policy/access-logs";
import { installedItems } from "@p0security/shared/install/installed";
import { Typography } from "@p0security/ui";

import type { AwsInstaller } from "../types";

const accessLogsInstructions: AwsInstaller["components"]["access-logs"]["instructions"] =
  (context, id) => {
    const awsPartition = awsPartitionFromUse(context.config, id, "access-logs");
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using{" "}
          <Typography.Link
            href={`https://${id}.signin.aws.amazon.com/console`}
            target="_blank"
            rel="noopener"
          >
            AWS Cloud Shell
          </Typography.Link>{" "}
          or Terraform:
        </>
      ),
      commands: {
        shell: [
          {
            command: accessLogsInstallCommands(
              context,
              {
                restrictResourceToARNs: [
                  context.config["access-logs"][id]?.cloudLakeArn,
                ],
              },
              {
                gcloudServiceAccountId:
                  context.config.base[id]?.serviceAccountId,
                awsAccountId: id,
                awsPartition,
              }
            ),
          },
        ],
        iac: [
          {
            command: accessLogsTerraform(
              context,
              {},
              context.config.base[id]?.serviceAccountId,
              awsPartition
            ),
          },
        ],
      },
    };
  };

export const awsAccessLogsInstaller: AwsInstaller["components"]["access-logs"] =
  {
    instructions: accessLogsInstructions,
    optionProvider: async ({ config }) => {
      const existingAccessLogs = installedItems("access-logs", config);
      return existingIamWriteAndAssessmentItems(config)
        .filter(([id]) => !(id in existingAccessLogs))
        .map(([id, item]) => ({
          id,
          label: item?.label,
        }));
    },
    items: {
      cloudLakeArn: {},
    },
  };
